module.exports = __webpack_public_path__ + "img/right-row.fe7a23d0.svg";